var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"id-card-mask"},[_c('span',{staticClass:"id-display"},[_vm._v(_vm._s(_vm.displayedId))]),(_vm.showToggle)?_c('span',{staticClass:"eye-icon",attrs:{"title":_vm.isRevealed ? '已显示，3秒后自动隐藏' : '显示完整身份证'},on:{"click":_vm.toggleVisible}},[_vm._v(" 👁️ ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }